import Api from './Api';

export default {
  fetch: params => Api.get('/v1/user/lessonRecords', { params }),
  createIndividual: data => Api.post('/v1/user/lessonRecords/individual', data),
};
